"use client";

import { useEffect, useState } from "react";
import { Search, Plus } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";

export const genres = [
  "Action",
  "Adventure",
  "Crime",
  "Children",
  "Comedy",
  "Dystopian",
  "Fantasy",
  "Fiction",
  "Graphic Novels",
  "Historical",
  "Horror",
  "Literary",
  "Mystery",
  "Romance",
  "Science Fiction",
  "Suspense",
  "Teen & Young Adult",
  "Thriller",
];

export const additionalGenres = [
  "Alien Invasion",
  "Alpha Male",
  "Alternate History",
  "American",
  "Ancient",
  "Ancient History",
  "Angel",
  "Angels",
  "Animal",
  "Asian Myth",
  "Billionaires & Millionaires",
  "Biographical",
  "Biography",
  "Black & African",
  "British & Irish",
  "Chinese",
  "Christian",
  "Christmas",
  "Classic",
  "College",
  "Colonization",
  "Coming of Age",
  "Contemporary",
  "Cozy Mystery",
  "Cyberpunk",
  "Dark Fantasy",
  "Dating",
  "Detective",
  "Domestic Life",
  "Dragons",
  "Drama",
  "Enemies to Lovers",
  "Epic Fantasy",
  "Erotica",
  "Espionage",
  "Facts of Life",
  "Fairy Tale",
  "Family",
  "Folklore",
  "Friendship",
  "Frontier",
  "Gay",
  "Ghost",
  "Gothic",
  "Growing Up",
  "Hard-Boiled",
  "Highlander",
  "Holiday",
  "Humor",
  "Humorous",
  "Inspirational",
  "International",
  "Interracial",
  "LGBTQ+",
  "Legal",
  "Legend",
  "Literature",
  "Mafia",
  "Magic",
  "Magical Realism",
  "Manga",
  "Medical",
  "Medieval",
  "Memoir",
  "Military",
  "Multicultural",
  "Murder",
  "Mythical",
  "Mythology",
  "New Adult",
  "Noir",
  "Occult",
  "Paranormal",
  "Philosophy",
  "Pirate",
  "Poetry",
  "Police",
  "Political",
  "Politics",
  "Post-Apocalyptic",
  "Private Investigator",
  "Psychic",
  "Psychological",
  "Regency",
  "Religious",
  "Roman",
  "Romantic",
  "Satire",
  "Scottish",
  "Serial Killer",
  "Shifter",
  "Short Reads",
  "Sleuth",
  "Sleuths",
  "Small Town",
  "Space",
  "Space Opera",
  "Spirit Guides",
  "Sports",
  "Spy",
  "Steampunk",
  "Superhero",
  "Supernatural",
  "Survival",
  "Sword & Sorcery",
  "Technothrillers",
  "Teen",
  "Time Travel",
  "United States",
  "Urban",
  "Urban Fantasy",
  "Vampire",
  "Victorian",
  "Viking",
  "Virtues",
  "War",
  "Werewolf",
  "Werewolves",
  "Western",
  "Witch",
  "Witches",
  "Wizard",
  "Women",
  "Workplace",
];

interface GenreFiltersProps {
  storageKey: "books" | "series";
  selectedGenres: string[];
  setSelectedGenres: (genres: string[]) => void;
}

const buttonClass =
  "border max-md:flex-auto border-white font-extrabold rounded-xl px-4 py-1 text-xs flex items-center max-md:justify-center select-none";

export function GenreFilters({
  storageKey,
  selectedGenres,
  setSelectedGenres,
}: GenreFiltersProps) {
  const [isMounted, setIsMounted] = useState(false);
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    const storedFilters = localStorage.getItem(storageKey);
    if (storedFilters) {
      setSelectedGenres(JSON.parse(storedFilters));
    }
    setIsMounted(true);
  }, [storageKey, setSelectedGenres]);

  useEffect(() => {
    if (isMounted) {
      localStorage.setItem(storageKey, JSON.stringify(selectedGenres));
    }
  }, [selectedGenres, storageKey, isMounted]);

  const handleFilterChange = () => {
    const params = new URLSearchParams(searchParams?.toString() || "");
    params.set("page", "1");
    router.push(`?${params.toString()}`, { scroll: false });
  };

  const renderGenres = () => {
    return (
      <div className="flex flex-wrap gap-2 max-md:justify-between">
        {genres.map(genre => (
          <button
            key={genre}
            className={`${buttonClass} ${
              selectedGenres.includes(genre) ? "bg-white text-slate-950" : ""
            }`}
            onClick={() => {
              if (selectedGenres.includes(genre)) {
                setSelectedGenres(
                  selectedGenres.filter(selectedGenre => selectedGenre !== genre)
                );
                handleFilterChange();
              } else {
                setSelectedGenres([...selectedGenres, genre]);
                handleFilterChange();
              }
            }}>
            <Search size={16} className="max-md:hidden mr-2" />
            {genre}
          </button>
        ))}
        {/* <button className={`${buttonClass} bg-white border-none text-black`}>
          <Plus size={16} className="mr-1" /> More Filters
        </button> */}
      </div>
    );
  };

  return <div>{renderGenres()}</div>;
}
